import { render, staticRenderFns } from "./CasterInfo.vue?vue&type=template&id=6daafab2"
import script from "./CasterInfo.vue?vue&type=script&lang=js"
export * from "./CasterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports